module.exports = __webpack_public_path__ + "files/SPIADI2026 - EXP ADI - Fiche Sepsis.ebf5962c3d86373260b33650e94c5a0e.pdf";